import { render } from "./NewServicesParameters.vue?vue&type=template&id=4ca6f43a&scoped=true"
import script from "./NewServicesParameters.vue?vue&type=script&lang=ts"
export * from "./NewServicesParameters.vue?vue&type=script&lang=ts"

import "./NewServicesParameters.vue?vue&type=style&index=0&id=4ca6f43a&lang=scss&scoped=true"
import "./NewServicesParameters.vue?vue&type=style&index=1&id=4ca6f43a&lang=scss"
script.render = render
script.__scopeId = "data-v-4ca6f43a"

export default script